
import BreadCrumb from "../screens/Common/BreadCrumb";
import React from "react";

import LayoutContainer from "../screens/layout/admin-dashboard";
import CategoryProfile from "../screens/CategoryDocumentUpload/CategoryProfile";

const breadCrumbData = [{ link: "/category-document-upload-list", name: "Project List" },
{ link: "/category-document-upload-detail", name: "Project Detail" }];

const CategoryManagement = () => (
  <>
    <LayoutContainer>
      <BreadCrumb data={breadCrumbData} />
      <CategoryProfile />
    </LayoutContainer>
  </>
);

export default CategoryManagement;